import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { tabStateTrigger } from './shared/animations'
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    tabStateTrigger
  ]
})
export class AppComponent implements OnInit {

  isLoggedIn$: Observable<boolean>
  isLoggedOut$: Observable<boolean>;
  user;

  constructor(private authService: AuthService, private router:Router ) {
    this.authService.getUserClientPromise2()
    .then(() => {
      this.authService.user$.subscribe((user:any) => {
        this.user = user;
        console.log(this.user)
        this.isLoggedIn$ = this.authService.isLoggedIn$;
    });
   });
  }

  ngOnInit() {
    // this.isLoggedIn$ = this.authService.isLoggedIn$
    // console.log(this.isLoggedIn$)

  }

  onLogOut() {
      this.authService.onLogOut()
      .then((message) => {
        this.authService.user$.subscribe((user:any) => {
      });
      })
  }



}



// WEBPACK FOOTER //
// ./src/app/app.component.ts